import Button from '@components/Button';
import Image from '@components/Image';
import Row from '@components/Row';
import colors from '@constants/colors';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import RecentToolTip from '../RecentToolTip';
import useSignInWIthApple from './hooks/useSignInWIthApple';
import AppleIcon from './ic_apple.svg';

interface Props {
    isLastLogin?: boolean;
}

function AppleSignInButton({ isLastLogin }:Props) {
    const { t } = useTranslation('signIn');
    const { isIos, handleAppleSignIn, appleClientId } = useSignInWIthApple();
    if (isIos && appleClientId) {
        return (
            <Button onClick={handleAppleSignIn}
                id='apple-sign-in-button'
                unmanagedBackground='#000'
                unmanagedColor={colors.white}
                fullWidth >
                <Row spacing={1.5}>
                    <Image src={AppleIcon}
                        width={20}
                        height={20}
                        alt={t('apple.alt')}/>
                    {t('apple.button')}
                </Row>
                {isLastLogin && (
                    <RecentToolTip/>
                )}
            </Button>
        );
    }
    return (<Fragment/>);
}

export default AppleSignInButton;
